import React from 'react';
import Loading from '../Loading/Loading';
import { Box, Paper } from '@material-ui/core';
import { myContainerStyle } from '../../configs/ui/constant';

const PageNotFound = () => {
   return (
      <Paper style={myContainerStyle.root}>
         <Box textAlign={'center'}>
            <Loading styles={'pageNotFound'} />
         </Box>
      </Paper>
   );
};

export default PageNotFound;
